


























import { Component, Vue } from 'vue-property-decorator';
import '../assets/css/AccountSetup.scss';
import '../assets/css/Common.scss';
import '../assets/css/MainLayout.scss';
import { ObjectFactory } from '@/config/objectFactory';
import { CommonUtils } from '@/util/commonUtils';
import HealthInsuranceForm from './account-setup/HealthInsuranceForm.vue';

@Component({
    components: {
        HealthInsuranceForm,
    },
})
export default class HealthInsurance extends Vue {

    private mounted() {
        this.getPartnerProfile();
    }

    private async getPartnerProfile() {
    const partnerService = ObjectFactory.getPartnerService();
    const response = await partnerService.getPartnerProfile(this.$store.state.serverUrl);
    }

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
